import { useAuth } from '@/lib/auth';
import { useLocation } from 'react-router-dom';
import { ShortcutBar } from '@/components/ShortcutBar';

/**
 * Shows the market-side ShortcutBar (Categorías, Ofertas, Ayuda, PQR…) on
 * anonymous / public pages only. Any logged-in user (buyer, seller or admin)
 * navigates via their role-specific DashboardNav, so the public shortcut bar
 * is hidden to keep the UX focused per role.
 */
export const PersistentShortcutBar = () => {
  const { user } = useAuth();
  const loc = useLocation();
  if (loc.pathname.startsWith('/admin')) return null;
  if (loc.pathname.startsWith('/vendedor')) return null;
  if (user) return null; // any authenticated user gets their own nav
  return <ShortcutBar />;
};
